import React from 'react';
import { DateInput, TextInput, EnumDropdown, LegalEntityEnum, ClearAfterUnmountWrapper } from 'framework/form';
import {
  AGREEMENT_TYPES_VALUES,
  VENDOR_DURACTION_TYPE_VALUES,
  AGREEMENT_TYPES,
  VENDOR_DURACTION_TYPE,
} from '../../constants';
import { VendorAgreementDto } from '../../types';
import ConditionalWrapper from 'domain/finance/vendors/shared/components/ConditionalWrapper';
import { NoteAttachmentUploaderInput } from 'domain/shared/artifact/input';

const CreateAgreementForm = () => (
  <>
    <LegalEntityEnum label="Legal entity" source="legalEntity" isRequired />

    <EnumDropdown label="Agreement type" source="agreementType" options={AGREEMENT_TYPES_VALUES} isRequired />

    <ConditionalWrapper
      isVisible={(formData: Partial<VendorAgreementDto>) => formData?.agreementType === AGREEMENT_TYPES.PUBLIC_OFFER}
    >
      <ClearAfterUnmountWrapper>
        <TextInput source="publicOfferLink" label="Public offer link" placeholder="Public offer link" isRequired />
      </ClearAfterUnmountWrapper>
    </ConditionalWrapper>

    <ConditionalWrapper
      isVisible={(formData: Partial<VendorAgreementDto>) => formData?.agreementType === AGREEMENT_TYPES.CONTRACT}
    >
      <ClearAfterUnmountWrapper>
        <NoteAttachmentUploaderInput
          source="signedContractAttachment"
          label="Signed contract attachment"
          isNewDocumentStorage
          isRequired
        />
      </ClearAfterUnmountWrapper>
    </ConditionalWrapper>

    <EnumDropdown label="Duration type" source="durationType" options={VENDOR_DURACTION_TYPE_VALUES} isRequired />

    <DateInput label="Start date" source="startDate" isRequired />

    <ConditionalWrapper
      isVisible={(formData: Partial<VendorAgreementDto>) => formData?.durationType !== VENDOR_DURACTION_TYPE.OPEN_ENDED}
    >
      <DateInput label="End date" source="endDate" isRequired />
    </ConditionalWrapper>

    <ConditionalWrapper
      isVisible={(formData: Partial<VendorAgreementDto>) => formData?.durationType === VENDOR_DURACTION_TYPE.OPEN_ENDED}
    >
      <DateInput label="End date" source="endDate" />
    </ConditionalWrapper>
  </>
);

export default CreateAgreementForm;
